<i18n lang="yaml" locale="en">
  content: Content
  click to edit: Click here to edit.
</i18n>

<i18n lang="yaml" locale="de">
  content: Inhalt
  click to edit: Klicken Sie hier zum Editieren.
</i18n>

<template>
  <div
    v-if="content"
    @click.capture="handleEdit"
    v-html="content"
    class="html"
  />
  <div
    v-else
    @click.capture="handleEdit"
  >
    <placeholder
      v-if="$editMode"
      :message="$t('click to edit')"
    />
  </div>
</template>

<script>
import Placeholder from '@/components/editor/Placeholder'
import BaseModule from '@/components/modules/BaseModule'
import translatable from '@/store/mixins/translatable'

export default {
  // eslint-disable-next-line vue/name-property-casing
  name: 'html',
  extends: BaseModule,
  customStore: translatable,
  components: {
    Placeholder
  },
  props: {
    content: {
      label: 'content',
      input: 'html',
      type: String,
      default: ''
    }
  },
  methods: {
    handleEdit () {
      if (this.$editMode) {
        this.$router.replace({ query: { edit: this.$store.getters.path } })
      }
    }
  }
}
</script>

<style lang="scss">
.html {
  h1, h2, h3, h4, h5, h6 {
    margin: 0;
    font-family: inherit;
    font-weight: 400;
    line-height: 1.2;
    color: inherit;
  }

  h1 {
    font-size: 3rem;
  }

  h2 {
    font-size: 2.5rem;
  }

  h3 {
    font-size: 2rem;
  }

  h4 {
    font-size: 1.5rem;
  }

  h5 {
    font-size: 1.25rem;
  }

  h6 {
    font-size: 1rem;
  }

  .text-center {
    text-align: center;
  }

  p {
    margin: 1.5rem 0;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
